import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useBrandContext from 'contexts/brand.context';
import PreviewBrandDetails from './preview-brand-details';
import EditBrandDetails from './edit-brand-details';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { BreadcrumbType, Breadcrumbs } from '@cokitchen/cokitchen-components';

const BrandDetailsPage = () => {
  const { activeBrand } = useBrandContext();
  const [editing, setEditing] = useState(
    new URLSearchParams(useLocation().search).get('edit') === 'true'
  );
  const [breadCrumbs, setBreadCrumbs] = useState([] as BreadcrumbType[]);

  useEffect(() => {
    if (activeBrand.archived) {
      setBreadCrumbs([
        { name: 'Trash', path: ROUTE_KEYS.TRASH },
        {
          name: `${activeBrand?.name ?? '...'}`,
          path: ''
        }
      ]);
    } else {
      setBreadCrumbs([
        { name: 'Overview', path: `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}` },
        {
          name: `${activeBrand?.name ?? '...'}`,
          path: ''
        }
      ]);
    }
  }, [activeBrand]);

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadCrumbs} />
      <PageHeaderText
        title={activeBrand?.name ?? 'brand'}
        description={`Update ${activeBrand?.name ?? 'brand'} details here`}>
        {!editing && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={() => {
              setEditing(true);
            }}>
            Edit
          </button>
        )}
      </PageHeaderText>
      {editing ? <EditBrandDetails /> : <PreviewBrandDetails />}
    </div>
  );
};

export default BrandDetailsPage;
